import {Column, Table} from 'fixed-data-table-2';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface EmptyScrollableTableProps {
  height: number;
  leftPadding: number;
  rowHeight: number;
  text?: string;
  width: number;
}

function getRowClassName(): string {
  return 'scrollableTable-row';
}

export default function EmptyScrollableTable({
  leftPadding,
  height,
  rowHeight,
  text,
  width,
}: EmptyScrollableTableProps): JSX.Element {
  return (
    <Table
      headerHeight={0}
      height={height}
      rowClassNameGetter={getRowClassName}
      rowsCount={1}
      rowHeight={rowHeight}
      width={width}
    >
      <Column
        width={leftPadding}
        // eslint-disable-next-line react/no-unstable-nested-components -- Disabling for now, but worth fixing
        cell={() => <div className="scrollableTable-cell scrollableTable-cell--empty" />}
      />
      <Column
        // eslint-disable-next-line react/no-unstable-nested-components -- Disabling for now, but worth fixing
        cell={() => (
          <div className="scrollableTable-cell scrollableTable-cell--empty scrollableTable-cell--isPrimary">
            <span
              className="u-faded"
              {...getTestProps({
                component: 'EmptyScrollableTable',
                element: 'text',
              })}
            >
              {text}
            </span>
          </div>
        )}
        width={width - leftPadding}
      />
    </Table>
  );
}
